import Tabs from 'components/Tabs/Tabs'
import TabItem from 'components/Tabs/TabItem'
import CameraGroupTable from './CameraGroupTable/CameraGroupTable'
import ServerSettings from './ServerSettings/ServerSettings'
import Proposals from './Proposal/Proposal'
import ProposalsHeaderPdf from './Pdf/ProposalHeaderPdf'
import CamerasGroupTablePdf from './Pdf/CameraGroupTablePdf'
import ServerSettingsPdf from './Pdf/ServerSettingsPdf'
import ProposalManagementPdf from './Pdf/ProposalManagementPdf'
import ProposalsDisclaimerPdf from './Pdf/ProposalDisclaimerPdf'
import ProposalsPdf from './Pdf/ProposalPdf'
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
import { SiteDesignEditorInitialization } from './SiteDesignEditorInitialization'
import { ButtonStyles } from '../../lib/enums'
import Button from '../../components/Button/Button'
import ProposalHuskyPdf from './Pdf/ProposalHuskyPdf'
import ValidationMessage from '../../components/ValidationMessage/ValidationMessage'

const SiteDesignEditor = () => {
  const {
    projectIdNumber,
    projectName,
    siteIdNumber,
    siteName,
    siteDesignIdNumber,
    siteDesignName,
    siteDesignData,
    proposalPropsData,
    saveSettingsButtonLabel,
    onGenerateProposalButtonClick,
    modifiedCameraRecordings,
    setModifiedCameraRecordings,
    setModifiedServerSettings,
    updatedCameraAmount,
    hardwareType,
    hasManagementServerValidationError,
    setHasManagementServerValidationError
  } = SiteDesignEditorInitialization()

  return (
    <div className="container-fluid">
      <div className="mt-6 mx-8 no-print-container">
        <Breadcrumb
          projectId={projectIdNumber.toString()}
          projectName={projectName}
          siteId={siteIdNumber.toString()}
          siteName={siteName}
          siteDesignId={siteDesignIdNumber.toString()}
          siteDesignName={siteDesignName}
        />
        <h1 className="msds-text-header-1 mb-8">{siteDesignName}</h1>
        <Tabs>
          <TabItem nameId="cameras" tabTitle="Cameras">
            <CameraGroupTable siteDesignPayload={siteDesignData} modifiedCameraRecordings={modifiedCameraRecordings} setModifiedCameraRecordings={setModifiedCameraRecordings} />
          </TabItem>
          <TabItem nameId="server-settings" tabTitle="Servers">
            <ServerSettings
              siteDesignPayload={siteDesignData}
              setModifiedServerSettings={setModifiedServerSettings}
              updatedCameraAmount={updatedCameraAmount}
              setHasManagementServerValidationError={setHasManagementServerValidationError}
            />
          </TabItem>
        </Tabs>
        {hasManagementServerValidationError && (
          <div className="mt-6">
            <ValidationMessage message={'The number of cameras exceeds the selected Management Server capacity. Please adjust the Server settings or reduce the number of cameras.'} />
          </div>
        )}

        <Button
          id={'xsd__e2e-save-settings-button'}
          label={saveSettingsButtonLabel}
          cssClass="my-9"
          icon={'article'}
          onClickHandler={onGenerateProposalButtonClick}
          styling={ButtonStyles.Tertiary}
          disabled={hasManagementServerValidationError}
        />
        {proposalPropsData && !hasManagementServerValidationError && <Proposals proposals={proposalPropsData}></Proposals>}
      </div>
      <div className="print-container">
        <ProposalsHeaderPdf proposals={proposalPropsData} />
        <CamerasGroupTablePdf siteDesignPayload={siteDesignData} />
        {hardwareType === 0 && (
          <>
            <ServerSettingsPdf siteDesignPayload={siteDesignData} />
            <ProposalsPdf proposals={proposalPropsData} />
          </>
        )}
        {hardwareType === 1 && <ProposalHuskyPdf proposals={proposalPropsData} />}
        <ProposalManagementPdf proposals={proposalPropsData} />
        <ProposalsDisclaimerPdf />
      </div>
    </div>
  )
}

export default SiteDesignEditor
